// Host reporting for the arcade cabinets other than Turkey Hunt. Turkey Hunt
// grades the course quiz through /t/<token>/quiz; the other cabinets send
// their per-decision detail to /sim/track only (same endpoint every 3D
// course uses). No new endpoints.

import { apiUrl, getHostConfig, isSpokeLoad } from "../../lib/hostConfig";
import type { CabinetResult } from "./results";

export interface DecisionRecord {
  /** Stable id of the decision (round id, ship id...). */
  id: string;
  topic: string;
  result: "correct" | "incorrect" | "skipped";
  points: number;
  responseMs?: number;
  detail?: string;
}

function readCookie(name: string): string | null {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}

export async function reportCabinet(
  beatId: string,
  moduleId: string,
  result: CabinetResult,
  decisions: DecisionRecord[],
): Promise<void> {
  const host = getHostConfig();
  if (!host.hosted || !host.token) return;
  if (isSpokeLoad()) return;
  const csrf = readCookie("cf_csrf");
  try {
    await fetch(apiUrl("/sim/track"), {
      method: "POST",
      headers: { "Content-Type": "application/json", ...(csrf ? { "X-CSRF-Token": csrf } : {}) },
      credentials: "include",
      body: JSON.stringify({
        token: host.token,
        kind: "sim_module",
        module_id: moduleId,
        event: "game_completed",
        score: {
          raw_score: result.rawScore,
          points: result.normalizedCoursePoints,
          correct: result.correctCount,
          incorrect: result.incorrectCount,
          total: result.totalAssessableDecisions,
          passed: result.passedCabinetThreshold,
          completed: result.completed,
        },
        outcomes: decisions.map((d) => ({
          type: "decision",
          beatId,
          eventId: d.id,
          evidence: d.result,
          topic: d.topic,
          points: d.points,
          responseMs: d.responseMs,
          detail: d.detail,
          at: Date.now(),
        })),
      }),
    });
  } catch {
    /* best-effort */
  }
}
